var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.LandingOfferSection
  }, [_c('span', {
    class: [_vm.$style.gradientCircle, _vm.$style.gradientCircle1]
  }), _vm._v(" "), _c('span', {
    class: [_vm.$style.gradientCircle, _vm.$style.gradientCircle2]
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: [_vm.$style.title, _vm.$style.gradientText],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c(_setup.LandingOffersSlider, {
    attrs: {
      "items": _vm.items
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };